import { render } from "./ActivityCard.vue?vue&type=template&id=abff4496&scoped=true"
import script from "./ActivityCard.vue?vue&type=script&lang=js"
export * from "./ActivityCard.vue?vue&type=script&lang=js"

import "./ActivityCard.vue?vue&type=style&index=0&id=abff4496&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abff4496"]])

export default __exports__